import React, {Component} from 'react';
import SignUpForm from './Forms/SignUp/SignUpForm';

class SignUp extends Component {
    render() {
        return (
            <SignUpForm/>
        )
    }
}

export default (SignUp);
